import React from 'react';
import {
  Link,
  useRouteError,
  isRouteErrorResponse,
} from 'react-router-dom';

export const  RouteError=()=> {
  const error = useRouteError();
  console.error('Route error:', error);

  // If you threw a Response with status, you can handle it:
  if (isRouteErrorResponse(error)) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <h1>{error.status} {error.statusText}</h1>
        <p>{error.data || 'Unexpected error occurred'}</p>
        <Link to="/">Back to Home</Link>
      </div>
    );
  }

  // Fallback for JS errors
  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h1>Something went wrong.</h1>
      <p>{(error instanceof Error) ? error.message : 'Unknown Error'}</p>
      <Link to="/">Back to Home</Link>
    </div>
  );
}

export default RouteError